export default function MeetingDeleteBody({ meeting }) {
  return (
    <div>
      <p>
        Are you sure you want to delete meeting <strong>{meeting.meetingTheme}</strong> on <strong>{meeting.meetingDate}</strong>?
      </p>
    </div>
  );
}